import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "6.5 6.5 39 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M27.952 7.04c4.4.271 8.524 2.435 11.549 5.41C43.075 16.239 45 20.838 45 26.248c0 4.328-1.65 8.386-4.4 11.903-2.749 3.246-6.598 5.68-10.998 6.492-4.4.811-8.799.27-12.648-1.894-3.85-2.164-6.874-5.41-8.524-9.468-1.65-4.057-1.925-8.656-.55-12.714 1.375-4.328 3.85-7.845 7.7-10.28 3.574-2.434 7.973-3.516 12.372-3.245Zm1.375 34.897c3.575-.812 6.874-2.705 9.349-5.681 2.2-2.976 3.574-6.492 3.3-10.28 0-4.328-1.65-8.656-4.675-11.632-2.75-2.705-6.05-4.328-9.899-4.598-3.574-.27-7.424.54-10.448 2.705-3.025 2.164-5.224 5.14-6.324 8.927-1.1 3.516-1.1 7.304.55 10.82 1.65 3.517 4.124 6.222 7.424 8.116a14.946 14.946 0 0 0 10.723 1.623Zm-3.3-17.313 6.6-6.763 1.924 1.894-6.599 6.762 6.6 6.763-1.925 1.894-6.6-6.763-6.598 6.763-1.925-1.894 6.599-6.763-6.6-6.762 1.926-1.894 6.599 6.763Z"
    }, null, -1)
  ]))]))
}
export default { render: render }